import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import style from "./style";
import DragAndDropMultiple from "../../../../components/DragAndDropMultiple";
import { useNavigate } from "react-router-dom";
import { Button, Checkbox, FormControl, FormControlLabel, FormLabel, MenuItem, Radio, RadioGroup, Select, TextField } from "@mui/material";

const ViewItem = ({ supplierList, ItemData, handleMarkActive }) => {
  const [files, setFiles] = useState();
  const [isActive, setIsActive] = useState(false);
  const [formData, setFormData] = useState({
    type: "Goods",
    title: "",
    unit: "",
    SKU: "",
    category: "",
    salesInformation: {
      sellingPrice: "",
      account: "",
      description: ""
    },
    purchaseInformation: {
      costPrice: "",
      account: "",
      description: "",
      preferredSupplier: ""
    },
    quantity: ""
  });
  const [trackInventory, setTrackInventory] = useState(true);
  const [showSalesInfo, setShowSalesInfo] = useState(false);
  const [showPurchaseInfo, setShowPurchaseInfo] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (ItemData) {
      setIsActive(ItemData.isActive);
    }
  }, [ItemData]);

  useEffect(() => {
    if (ItemData) {
      setFormData({
        type: ItemData.type || "Goods",
        title: ItemData.title || "",
        unit: ItemData.unit || "",
        SKU: ItemData.SKU || "",
        category: ItemData.category || "",
        salesInformation: {
          sellingPrice: ItemData.salesInformation?.sellingPrice || "",
          account: ItemData.salesInformation?.account || "",
          description: ItemData.salesInformation?.description || ""
        },
        purchaseInformation: {
          costPrice: ItemData.purchaseInformation?.costPrice || "",
          account: ItemData.purchaseInformation?.account || "",
          description: ItemData.purchaseInformation?.description || "",
          preferredSupplier: ItemData.purchaseInformation?.preferredSupplier || ""
        },
        quantity: ItemData.quantity || ""
      });
      setTrackInventory(ItemData.quantity ? true : false);
    }
  }, [ItemData]);

  const handleChange = (field, value) => {
    if (field.includes('.')) {
      const [parent, child] = field.split('.');
      setFormData(prev => ({
        ...prev,
        [parent]: {
          ...prev[parent],
          [child]: value
        }
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [field]: value
      }));
    }
  };

  const handleMarkClick = () => {
    handleMarkActive(!isActive);
    setIsActive(!isActive);
  };

  return (
    <>
      <Box px="15px" mt={2}>
        <Box sx={style.headerContainer}>
          <Typography sx={style.leaveHeading}>View Inventory</Typography>
          <Box sx={style.buttonContainer}>
            <Button
              variant="contained"
              sx={style.markButton}
              onClick={handleMarkClick}
            >
              {isActive ? "Mark Inactive" : "Mark Active"}
            </Button>
          </Box>
        </Box>
      </Box>
      <form>
        <Grid container>
          <Grid item xs={12} lg={7.5} sx={style.gridbox}>
            <Box sx={style.inputSection}>
              <Box sx={style.inputBox}>
                <FormControl>
                  <FormLabel sx={{
                    fontSize: '14px',
                    fontWeight: '500',
                    color: '#333',
                    marginBottom: '8px',
                    marginTop: '10px'
                  }}>
                    Type
                  </FormLabel>
                  <RadioGroup
                    row
                    value={formData.type}
                    onChange={(e) => handleChange("type", e.target.value)}
                  >
                    <FormControlLabel
                      value="Goods"
                      control={<Radio size="small" disabled />}
                      label={<Typography fontSize="14px">Goods</Typography>}
                    />
                    <FormControlLabel
                      value="Service"
                      control={<Radio size="small" disabled />}
                      label={<Typography fontSize="14px">Services</Typography>}
                    />
                  </RadioGroup>
                </FormControl>
              </Box>
              <Box sx={style.inputBox}>
                <Typography sx={{
                  fontSize: '14px',
                  fontWeight: '500',
                  color: '#333',
                  marginBottom: '8px',
                  marginTop: '10px'
                }}>
                  Item Title
                </Typography>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  disabled
                  error={""}
                  placeholder="Enter item title"
                  name="title"
                  value={formData.title}

                  onChange={(e) => handleChange("title", e.target.value)}
                  autoComplete="title"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: '14px',
                      borderRadius: '8px'
                    }
                  }}
                />
              </Box>
            </Box>
            <Box sx={style.inputSection}>
              <Box sx={style.inputBox}>
                <FormControl fullWidth sx={{
                  "& .MuiOutlinedInput-root": {
                    height: "2.8em",
                    borderRadius: "8px",
                    fontSize: '14px'
                  }
                }}>
                  <Typography sx={{
                    fontSize: '14px',
                    fontWeight: '500',
                    color: '#333',
                    marginBottom: '8px',
                    marginTop: '10px'
                  }}>
                    Unit
                  </Typography>
                  <Select
                    fullWidth
                    required
                    disabled
                    id="unit"
                    name="unit"
                    value={formData.unit}
                    onChange={(e) => handleChange("unit", e.target.value)}
                    displayEmpty
                    sx={{
                      ...style.dropDownMenu,
                      fontSize: '14px'
                    }}
                  >
                    <MenuItem value="" disabled>Select Unit</MenuItem>
                    <MenuItem value="box">Box</MenuItem>
                    <MenuItem value="cm">cm</MenuItem>
                    <MenuItem value="dz">dz</MenuItem>
                    <MenuItem value="ft">ft</MenuItem>
                    <MenuItem value="g">g</MenuItem>
                    <MenuItem value="in">in</MenuItem>
                    <MenuItem value="kg">kg</MenuItem>
                    <MenuItem value="km">km</MenuItem>
                    <MenuItem value="lb">lb</MenuItem>
                    <MenuItem value="mg">mg</MenuItem>
                    <MenuItem value="ml">ml</MenuItem>
                    <MenuItem value="m">m</MenuItem>
                    <MenuItem value="pcs">pcs</MenuItem>
                  </Select>
                </FormControl>

              </Box>
              <Box sx={style.inputBox}>
                <FormControl fullWidth sx={{
                  "& .MuiOutlinedInput-root": {
                    height: "2.8em",
                    borderRadius: "8px",
                    fontSize: '14px'
                  }
                }}>
                  <Typography sx={{
                    fontSize: '14px',
                    fontWeight: '500',
                    color: '#333',
                    marginBottom: '8px',
                    marginTop: '10px'
                  }}>
                    Category
                  </Typography>
                  <Select
                    fullWidth
                    required
                    id="category"
                    disabled
                    name="category"
                    value={formData.category}
                    onChange={(e) => handleChange("category", e.target.value)}
                    displayEmpty
                    sx={{
                      ...style.dropDownMenu,
                      fontSize: '14px'
                    }}
                  >
                    <MenuItem value="" disabled>Select Category</MenuItem>
                    <MenuItem value="Electronics">Electronics</MenuItem>
                    <MenuItem value="Clothing">Clothing</MenuItem>
                    <MenuItem value="Food">Food</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </Box>
            <Box sx={style.inputSection}>
              <Box sx={style.inputBox}>
                <Typography sx={{
                  fontSize: '14px',
                  fontWeight: '500',
                  color: '#333',
                  marginBottom: '8px',
                  marginTop: '10px'
                }}>
                  SKU
                </Typography>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  id="SKU"
                  disabled
                  placeholder="Enter SKU"
                  error={""}
                  name="SKU"
                  value={formData.SKU}
                  onChange={(e) => handleChange("SKU", e.target.value)}
                  autoComplete="SKU"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: '14px',
                      borderRadius: '8px'
                    }
                  }}
                />
              </Box>
            </Box>
          </Grid>

          <Grid item xs={12} lg={4} sx={style.gridbox}>
            <Box sx={{ ...style.productSection, minHeight: '224px' }}>
              <Typography sx={{
                fontSize: '14px',
                fontWeight: '500',
                color: '#333',
                mb: 2
              }}>
                Product Images
              </Typography>
              <DragAndDropMultiple handleUrl={(file) => setFiles(file)} disabled />
            </Box>
          </Grid>
        </Grid>
        <Box sx={style.gridbox}>
          <Grid container>
            <Grid item xs={12} lg={6} >
              <Box sx={style.leaveSection}>
                <Box>
                  <FormControlLabel
                    control={
                      <Checkbox
                        disabled
                        checked={showSalesInfo}
                        onChange={(e) => setShowSalesInfo(e.target.checked)}
                        size="small"
                      />
                    }
                    label="Sales Information"
                  />
                </Box>
              </Box>
              <Box sx={style.leaveSection}>
                <Box sx={{ width: "100%", display: 'flex', flexDirection: 'row', gap: "40px" }}>
                  <Typography sx={style.inputTextNew}>Selling Price<span style={{ color: "red" }}>*</span> </Typography>
                  <TextField
                    variant="outlined"
                    required
                    fullWidth
                    disabled
                    type="number"
                    placeholder="Selling Price"
                    error={""}
                    name="sellingPrice"
                    value={formData.salesInformation.sellingPrice}
                    onChange={(e) => handleChange("salesInformation.sellingPrice", e.target.value)}
                    autoComplete="sellingPrice"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        fontSize: '14px',
                        borderRadius: '8px'
                      }
                    }}
                  />
                </Box>
              </Box>
              <Box sx={style.leaveSection}>
                <Box sx={{ width: "100%", display: 'flex', flexDirection: 'row', gap: "40px" }}>
                  <Typography sx={style.inputText}>Account<span style={{ color: "red" }}>*</span></Typography>
                  <TextField
                    variant="outlined"
                    fullWidth
                    placeholder="Account"
                    error={""}
                    disabled
                    name="salesAccount"
                    value={formData.salesInformation.account}
                    onChange={(e) => handleChange("salesInformation.account", e.target.value)}
                    autoComplete="salesAccount"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        fontSize: '14px',
                        borderRadius: '8px'
                      }
                    }}
                  />
                </Box>
              </Box>
              <Box sx={style.leaveSection}>
                <Box sx={{ width: "100%", display: 'flex', flexDirection: 'row', gap: "40px" }}>
                  <Typography sx={style.inputText}>Description</Typography>
                  <TextField
                    variant="outlined"
                    fullWidth
                    placeholder="Description"
                    disabled
                    name="salesDescription"
                    error={""}
                    value={formData.salesInformation.description}
                    onChange={(e) => handleChange("salesInformation.description", e.target.value)}
                    autoComplete="salesDescription"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        fontSize: '14px',
                        borderRadius: '8px'
                      }
                    }}
                  />
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} lg={6}>
              <Box sx={style.leaveSection}>
                <Box>
                  <FormControlLabel
                    control={
                      <Checkbox
                        disabled
                        checked={showPurchaseInfo}
                        onChange={(e) => setShowPurchaseInfo(e.target.checked)}
                        size="small"
                      />
                    }
                    label="Purchase Information"
                  />
                </Box>
              </Box>
              <Box sx={style.leaveSection}>
                <Box sx={{ width: "100%", display: 'flex', flexDirection: 'row', gap: "40px" }}>
                  <Typography sx={style.inputText}>Cost Price<span style={{ color: "red" }}>*</span> </Typography>
                  <TextField
                    variant="outlined"
                    required
                    type="number"
                    fullWidth
                    disabled
                    error={""}
                    placeholder="Cost Price"
                    name="costPrice"
                    value={formData.purchaseInformation.costPrice}
                    onChange={(e) => handleChange("purchaseInformation.costPrice", e.target.value)}
                    autoComplete="costPrice"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        fontSize: '14px',
                        borderRadius: '8px'
                      }
                    }}
                  />
                </Box>

              </Box>
              <Box sx={style.leaveSection}>
                <Box sx={{ width: "100%", display: 'flex', flexDirection: 'row', gap: "40px" }}>
                  <Typography sx={style.inputText}>Account</Typography>
                  <TextField
                    variant="outlined"
                    fullWidth
                    placeholder="Account"
                    disabled
                    name="purchaseAccount"
                    value={formData.purchaseInformation.account}
                    onChange={(e) => handleChange("purchaseInformation.account", e.target.value)}
                    autoComplete="purchaseAccount"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        fontSize: '14px',
                        borderRadius: '8px'
                      }
                    }}
                  />
                </Box>
              </Box>
              <Box sx={style.leaveSection}>
                <Box sx={{ width: "100%", display: 'flex', flexDirection: 'row', gap: "40px" }}>
                  <Typography sx={style.inputText}>Description</Typography>
                  <TextField
                    variant="outlined"
                    fullWidth
                    disabled
                    placeholder="Description"
                    name="purchaseDescription"
                    error={""}
                    value={formData.purchaseInformation.description}
                    onChange={(e) => handleChange("purchaseInformation.description", e.target.value)}
                    autoComplete="purchaseDescription"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        fontSize: '14px',
                        borderRadius: '8px'
                      }
                    }}
                  />
                </Box>
              </Box>
              <Box sx={style.leaveSection}>
                <Box sx={{ width: "100%", display: 'flex', flexDirection: 'row', gap: "40px" }}>
                  <Typography sx={style.inputText}>Preferred Supplier</Typography>
                  <Select
                    fullWidth
                    name="preferredSupplier"
                    disabled
                    value={formData.purchaseInformation.preferredSupplier}
                    onChange={(e) => handleChange("purchaseInformation.preferredSupplier", e.target.value)}
                    displayEmpty
                    sx={{
                      ...style.dropDownMenu,
                      fontSize: '14px'
                    }}
                  >
                    <MenuItem value="" disabled>Select Supplier</MenuItem>
                    {supplierList?.map((supplier) => (
                      <MenuItem key={supplier._id} value={supplier._id}>
                        {supplier.name}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
        {formData.type === "Goods" && (
          <Box sx={style.gridbox}>
            <Grid container>
              <Grid item xs={12} lg={6}>
                <Box sx={style.leaveSection}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        disabled
                        checked={trackInventory}
                        onChange={(e) => setTrackInventory(e.target.checked)}
                        size="small"
                        sx={{ color: '#28AA4A' }}
                      />
                    }
                    label={
                      <Box>
                        <Typography fontSize="14px" fontWeight={500}>
                          Track Inventory for this Item
                        </Typography>
                        <Typography fontSize="12px" color="#878787" sx={{ mt: 0.5 }}>
                          {"You cannot enable/disable inventory tracking once you've created transactions for this item"}
                        </Typography>
                      </Box>
                    }
                  />
                </Box>
              </Grid>
              <Grid item xs={12} lg={6}>
                <Box sx={{ width: '90%', display: 'flex', flexDirection: 'column', gap: "10px" }}>
                  <Typography sx={{
                    fontSize: '14px',
                    fontWeight: '500',
                    color: '#333'
                  }}>
                    Opening Stock
                  </Typography>
                  <TextField
                    variant="outlined"
                    fullWidth
                    type="number"
                    placeholder="0"
                    disabled
                    name="quantity"
                    value={formData.quantity}
                    onChange={(e) => handleChange("quantity", e.target.value)}
                    autoComplete="quantity"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        fontSize: '14px',
                        borderRadius: '8px'
                      }
                    }}
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>
        )}
      </form >
    </>
  );
};

export default ViewItem;